/**
 * @generated SignedSource<<5d06abc7abaf21288d9c0bdb6f5022ea>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AMLQuestionType = "INPUT_FIELD" | "MULTIPLE_CHOICE" | "SINGLE_CHOICE";
export type AmlQuestionsViewQuery$variables = {
  first: number;
};
export type AmlQuestionsViewQuery$data = {
  readonly amlQuestions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "AMLQuestion";
        readonly answers: ReadonlyArray<{
          readonly answer: string | null | undefined;
          readonly id: string;
          readonly nestedQuestions: ReadonlyArray<{
            readonly answers: ReadonlyArray<{
              readonly answer: string | null | undefined;
              readonly id: string;
            }> | null | undefined;
            readonly description: string | null | undefined;
            readonly id: string;
            readonly question: string | null | undefined;
            readonly type: AMLQuestionType;
          }> | null | undefined;
        }> | null | undefined;
        readonly description: string | null | undefined;
        readonly id: string;
        readonly question: string | null | undefined;
        readonly type: AMLQuestionType;
      } | null | undefined;
    } | null | undefined>;
  } | null | undefined;
  readonly termsAndConditions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "TermsAndConditions";
        readonly accepted: boolean;
        readonly id: string;
        readonly mandatory: boolean | null | undefined;
        readonly source: string | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
        readonly version: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type AmlQuestionsViewQuery = {
  response: AmlQuestionsViewQuery$data;
  variables: AmlQuestionsViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "question",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "answer",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "AMLQuestionConnection",
    "kind": "LinkedField",
    "name": "amlQuestions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AMLQuestionEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AMLQuestion",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AMLAnswer",
                "kind": "LinkedField",
                "name": "answers",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AMLQuestion",
                    "kind": "LinkedField",
                    "name": "nestedQuestions",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AMLAnswer",
                        "kind": "LinkedField",
                        "name": "answers",
                        "plural": true,
                        "selections": [
                          (v1/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "input",
        "value": {
          "first": 100
        }
      }
    ],
    "concreteType": "TermsAndConditionsConnection",
    "kind": "LinkedField",
    "name": "termsAndConditions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TermsAndConditionsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TermsAndConditions",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "version",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "source",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accepted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mandatory",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "termsAndConditions(input:{\"first\":100})"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AmlQuestionsViewQuery",
    "selections": (v7/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AmlQuestionsViewQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "e9f910d5dcca1194681ba5027353acbf",
    "id": null,
    "metadata": {},
    "name": "AmlQuestionsViewQuery",
    "operationKind": "query",
    "text": "query AmlQuestionsViewQuery(\n  $first: Int!\n) {\n  amlQuestions(input: {first: $first}) {\n    edges {\n      node {\n        id\n        question\n        description\n        type\n        answers {\n          id\n          answer\n          nestedQuestions {\n            id\n            question\n            description\n            type\n            answers {\n              id\n              answer\n            }\n          }\n        }\n        __typename\n      }\n    }\n  }\n  termsAndConditions(input: {first: 100}) {\n    edges {\n      node {\n        id\n        type\n        title\n        version\n        source\n        accepted\n        mandatory\n        __typename\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c63fe3f6ab4636c1737a5c64fb0c48b8";

export default node;
